
























































































































import { ShowCaseCreditsListVueGB } from "@/extensions/products/ShowCaseCreditsListVueGB";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { BackLink, Preloader }
})
export default class ShowCaseCreditCalc extends ShowCaseCreditsListVueGB {

	async mounted(): Promise<void> {
		this.init();
		await this.calculateCredit();
	}

}
